<template>
  <div class="loading-wheel" :class="{ rotate: rotate }" :style="wheelStyle"></div>
</template>

<style lang="scss" scoped>
.loading-wheel {
  border-top: 1px #000 solid;
  border-left: 1px #000 solid;
  border-bottom: 1px #000 solid;
  border-right: 1px transparent solid;
  border-radius: 100%;
  box-sizing: content-box;
  transform-origin: center center;

  &.rotate {
    animation: rotate 0.5s linear 0s infinite normal;
  }
}

@keyframes rotate {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
</style>

<script>
export default {
  name: 'loading-wheel',
  computed: {
    wheelStyle () {
      return {
        width: this.size,
        height: this.size
      }
    }
  },
  props: {
    rotate: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: '1em'
    }
  }
}
</script>
